import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { AzureDevOpsRepoIntegration, Maybe } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { DELETE_AZURE_DEVOPS_INTEGRATION } from "./gql";

const useDeleteAzureDevOpsIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [azureDevOpsRepoIntegrationDelete, { loading }] = useMutation<{
    azureDevOpsRepoIntegrationDelete: Maybe<AzureDevOpsRepoIntegration>;
  }>(DELETE_AZURE_DEVOPS_INTEGRATION, {
    refetchQueries: ["SearchVCSIntegrations"],
  });

  const deleteAzureDevOpsIntegration = useCallback(
    (id: string, attachedEntitiesQty: number, successCallback?: () => void) => {
      return azureDevOpsRepoIntegrationDelete({
        variables: {
          id,
        },
      })
        .then(({ data }) => {
          if (data) {
            reportSuccess({
              message: `${
                data?.azureDevOpsRepoIntegrationDelete?.name || "Azure DevOps"
              }  integration successfully deleted`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Integration - Unlink Confirm", {
              attachedEntitiesQty,
              integration: "Azure DevOps",
            });
          }
        })
        .catch(onError);
    },
    [azureDevOpsRepoIntegrationDelete, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return { deleteAzureDevOpsIntegration, loading };
};

export default useDeleteAzureDevOpsIntegration;
